import Action from '../../Action'
import './styles/ModalDeleteUSer.css'
import { useState } from 'react';
import LoadSimple from '../../LoadSimple';
import { capitalizeFirstLetter } from '../../../utils/utils';
import { lang } from '../../generales/traduction';
const ModalMsgError =({user,closDeleteUserModal,languaje})=>{
    const [loadingM,setLoadingM]=useState(false);


    return(
        <div className="modal-GS-content">
            <div className='card-modal-gs delete-modal-gs'>
                            {/* <div className='head-card-users delete-modal-gs'>
                                <div className='title-head-card-modal-gs'>
                                   CERRAR EXCEPCION
                                </div>
                            </div> */}
                            <div className='content-card-modal-gs' style={{height:'100%'}}>
                                <div className='cont-info-modal-delete-gs'  style={{height:'100%'}}>
                                    <div className='cont-message-modal-delete-gs' style={{height:'20%'}}>
                                            <div className='txt-message-modal-delete-gs'>
                                                {user.status_text.toUpperCase()+"  "+lang[languaje]['workflow'].toUpperCase()}:
                                            </div>
                                    </div>
                                    <div className='cont-user-modal-delete-gs' style={{overflow:'auto',alignItems:'unset',height:'60%'}}>
                                            <div className='txt-user-modal-delete-gs' >
                                                {user.creation_details}
                                                
                                            </div>
                                    </div>
                                    <div className='cont-btn-modal-delete-gs'  style={{height:'20%'}}>
                                            {
                                                (loadingM)?<LoadSimple></LoadSimple>:
                                                <>
                                                
                                            <Action  disabled={false} origen='Cancelar' titulo='Aceptar'  action={closDeleteUserModal}></Action>
                                                </>
                                            }
                                    </div>
                                </div>
                            </div>
            </div>
        </div>
    )
}

export default ModalMsgError